<section class="page-section" id="jobs">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Job details</h2>
          <h3 class="section-subheading">view details below</h3>
        </div>
      </div>
      <div>
        <h4 class="text-fsp">{{job.title}}</h4>
        <h6 class="text-muted" *ngIf="salary !== ''"><i class="fa fa-money"></i> {{salary}}</h6>
        <h6 class="text-muted" *ngIf="job.contract !== ''"><i class="fa fa-pagelines"></i> {{job.contract}}</h6>
        <h6 class="text-muted" *ngIf="job.location.name !== ''"><i class="fa fa-map-marker"></i> {{job.location.name}}</h6>
        
        <p class="py-2">{{job.description}}</p>
        
        <div *ngIf="job.requirements.length > 0">
          <h5 class="text-fsp-secondary">Requirements</h5>
          <ul>
            <li *ngFor="let requirement of job.requirements">{{requirement}}</li>
          </ul>
        </div>
        <div *ngIf="job.education.length > 0">
          <h5 class="text-fsp-secondary">Education</h5>
          <ul>
            <li *ngFor="let singleEducation of job.education">{{singleEducation}}</li>
          </ul>
        </div>
        <div *ngIf="job.skills.length > 0">
          <h5 class="text-fsp-secondary">Skills</h5>
          <ul>
            <li *ngFor="let skill of job.skills">{{skill}}</li>
          </ul>
        </div>
        <div *ngIf="job.duties.length > 0">
          <h5 class="text-fsp-secondary">Duties</h5>
          <ul>
            <li *ngFor="let duty of job.duties">{{duty}}</li>
          </ul>
        </div>
      </div>
      <div>
       <button mat-ripple class="btn btn-fsp" routerLink="./apply">Apply</button>
      </div>
</div>
</section>

